<script lang="ts">
	import FlexibleComponents from '$lib/pages/FlexibleComponents.svelte'
	import BlogCatBanner from '$lib/blog/BlogCatBanner.svelte'
	import StructuredData from '$lib/components/common/StructuredData.svelte'
	import { t } from 'svelte-i18n-lingui'
	import { getMerchantSchema, getPostSchema } from '$lib/js/structured_data'
	import { is_set_object } from '$lib/js/helpers'
	import { getContextScope } from '$lib/js/helpers/i18n'

	export let data: import('./$types').PageData

	const scope = getContextScope()
</script>


{#key data}
	{#if is_set_object(data.page_data)}
		<StructuredData schema={getPostSchema(data.page_data)} />
	{/if}

	{#if is_set_object(data.products)}
		{#each data.products as product}
			{#if product}
				<StructuredData schema={getMerchantSchema(product, {scope: scope})} />
			{/if}
		{/each}
	{/if}

	<FlexibleComponents/>
	<BlogCatBanner title="{$t`Other news at bixoto`}" posts={data.related_posts} />
{/key}
